import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import Page from '../../components/Page';
import { SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const ManageAds = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [searchtext, setSearchtext] = useState('');

  const { sendNetworkRequest } = React.useContext(NetworkContext);

  async function fetchallads() {
    let ads = await sendNetworkRequest('/admin/getads', {}, {}, false)
    setOrders(ads && Array.isArray(ads.module) ? ads.module : [])
  }
  useEffect(() => {
    fetchallads()
  }, []);
  function onSearch(value)
  {
    setSearchtext(value || '')
  }
  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
      <SearchBar   onSearch={onSearch} />
      <Results
        className={classes.results}
        orders={orders}
        searchtext={searchtext}
      />

    </Page>
  );
});

export default ManageAds;
